import React, { useState } from 'react';
import { Container, Typography } from '@design-system';
import './HeaderToggle.scss';

type HeaderToggleProps = {
    children: React.ReactNode[];
    labels: string[];
    onToggle?: (index: number) => void;
};

type HeaderButtonProps = {
    label: string;
    isActive: boolean;
    onClick: () => void;
};

const HeaderButton: React.FC<HeaderButtonProps> = ({ label, isActive, onClick }) => {
    return (
        <button type="button" className={`header-toggle-button ${isActive ? 'active' : ''}`} onClick={onClick}>
            <Typography intrinsic="h4">{label}</Typography>
        </button>
    );
};

export const HeaderToggle: React.FC<HeaderToggleProps> = ({ children, labels, onToggle }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const handleToggle = (index: number) => {
        setActiveIndex(index);
        onToggle?.(index);
    };

    return (
        <div className="header-toggle-wrapper">
            <div className="header-toggle-buttons-wrapper">
                <Container className="header-toggle-buttons" data-active={activeIndex}>
                    {labels.map((label, index) => (
                        <HeaderButton key={label} label={label} isActive={activeIndex === index} onClick={() => handleToggle(index)} />
                    ))}
                </Container>
            </div>

            <div className="header-toggle-content">{React.Children.toArray(children)[activeIndex]}</div>
        </div>
    );
};
